import React, { useEffect, useRef, useState } from "react";
import { match } from "react-router-dom";
import Grid from "@material-ui/core/Grid";
import styled from "styled-components";
import MUIDataTable, {
  MUIDataTableColumnDef,
  MUIDataTableOptions,
} from "mui-datatables";
import IRouterComponentProps from "../../../models/IRouterComponentProps";
import AuthService from "../../auth/AuthService";
import {
  tendorBidUrl,
  productDownload,
  getBidInfo,
  getAuctionEndTimeUrl,
  auctionTendorMyBids,
  productUrl,
  getMyLatestBidsForUser,
} from "../../../common/config/app.endpoints";
import Alert from "../../../common/elements/Alert";
import LoadingSpinner from "../../../common/elements/LoadingSpinner";
import { oAuth } from "../../../routes/basic/BasicAppRouter";
import {
  StyledButton,
  StyledModal,
} from "../../../common/materials/GenericStyleComponent";
import BlockUserModal from "../BlockUser/BlockUserModal";

import { MuiThemeProvider, useTheme } from "@material-ui/core/styles";
import update from "immutability-helper";
import moment from "moment";
import { StyledButtonGray } from "./JewelleryTendorAuctionView";
import EllipsisText from "../../../common/elements/EllipsisText";
import ActionTenderPagesize from "../../core-grid/grid-actions/ActionTenderPagesize";
import {
  createTheme,
  IconButton,
  Menu,
  MenuItem,
  useMediaQuery,
} from "@material-ui/core";
import {
  StyledButtonView,
  StyledButtonViewFilter,
  Styledview,
} from "./TendorPreviewView";
import copy from "copy-to-clipboard";
import {
  faEdit,
  faHeart,
  faShareSquare,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ViewEndedModal from "../auction/ViewEndedModal";
import ViewTenderExtendedModal from "../auction/ViewTenderExtendedModal";
import {
  convertedValue,
  getReturnMyLatestStoredBid,
} from "./TenderGenericFunc";
import ColorLensIcon from "@material-ui/icons/ColorLens";
import JwlBulkBidPopup from "./bidPopupComponent/JwlBulkBidPopup";
import JwlTenderSlider from "./bidPopupComponent/JwlTenderSlider";
import CoreDataGridOfTenderJwl from "./tenderMobileComponets/CoreDataGridOfTenderJwl";
import { openJewelleryCertificateLinkPopup } from "../../../common/GenericFunctions";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import PubSub from "pubsub-js";
import AlertReadOnlyUser from "../../../common/elements/AlertReadOnlyUser";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import {
  JwlIsMyBidstabSelected,
  setJwlIsMybids,
} from "../../../redux/slice/commanPagination/commanPaginationSlice";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "../../../redux/store";
import {
  resetColorFilter,
  resetTenderGridProductIndexes,
  resetTenderjewellerySelectAll,
  resetTenderJwlIsGridView,
  selectedColorFilter,
  selectTenderJwlGridView,
  setColorFilter,
  setTenderGridProductIndexes,
  setTenderjewellerySelectAll,
  setTenderJwlIsGridView,
} from "../../../redux/slice/annual/commanAnnualSlice";
import { RootState } from "../../../redux/reducer";
import {
  StyledContainer,
  StyledPageSizeSelectorContainer,
} from "../../365Auction/component/DiamondProductMyBids";
import { StyledSelectAllButtonHeader } from "../../365Auction/component/DiamondProductStyle";
import TenderListOfProductMybids from "./tenderMobileComponets/TenderListOfProductMybids";

const faEditProps = faEdit as IconProp;
const faHeartProps = faHeart as IconProp;
const faShareSquareProps = faShareSquare as IconProp;

interface DetailParams {
  auctionId: string;
  auctionUserId: string;
  auctionDate: string;
  auctionName: string;
}

export interface IProductViewProps extends IRouterComponentProps {
  match: match<DetailParams>;
  t?: any;
  location: any;
}
const StyledHeaderContainer = styled(Grid)`
  padding-top: 0px;
`;
const StyledLayoutGridMain = styled(Grid)`
  .MuiIconButton-edgeEnd {
    display: contents !important;
    transition: width 5s !important;
  }
  .MuiAccordionSummary-root {
    min-height: 10px !important;
    transition: width 4s !important;
  }
  .MuiPaper-root {
    box-shadow: none !important;
  }
  .AccordionHeader {
    top: 70px;
    width: 100%;
    transition: width 1s;

    @keyframes fadeMe {
      from {
        opacity: 0;
      }
      to {
        opacity: 1;
      }
    }
    ${(props) => props.theme.breakpoints.down("md")} {
      width: 100%;
    }
    ${(props) => props.theme.breakpoints.between("xs", "md")} {
      top: 58px;
      width: 100% !important;
    }
  }
`;

const StyledLayoutGrid = styled(Grid)`
  // padding: 10px;
  width: 100%;
  .MuiPaper-root {
    width: 100%;
  }
  .MuiTableCell-root {
    padding: 7px;
    border: 1px solid lightgray;
    // z-index: 0;
  }
  .MuiToolbar-regular {
    min-height: 0px;
  }
  .MuiTableCell-head {
    background: ${(props) => props.theme.colors.base.buttonGradientFirstColor};
    color: white;
    text-align: center;
    font-weight: 700;
    border: 1px solid lightgray;
  }

  .MuiTableCell-root {
    text-align: center;
    // position: relative;
  }

  .MuiTableCell-head .MuiButton-root {
    color: white;
    text-align: center;
    font-weight: 700;
  }
  .linkCss {
    text-decoration: underline;
    color: blue;
    cursor: pointer;
  }
  ${(props) => props.theme.breakpoints.between("xs", "md")} {
    // padding: 10px 10px;
    .MuiTableHead-root {
      display: flex !important;
    }
    .MuiTableCell-root {
      text-align: center;
      max-width: 400px;
      border: none;
    }
  }
`;
const StyledBtnContainer = styled.div`
  text-align: center;
`;

const StyledCoreDataGridContainer = styled(Grid)``;
const StyledTextWrapper = styled(Grid)`
  margin: auto;
  text-align: center;
`;
const StyledActionBarContainer = styled(Grid)`
  display: flex;
  align-items: center;
  padding: 10px;
  margin: 10px 0px 10px 0px;
  border-radius: 5px;
  box-shadow: 2px 0px 5px 2px ${(props) => props.theme.colors.base.lightGrey};
  justify-content: flex-end;
  &:focus {
    outline: none;
  }
`;

const StyledButtonHeader = styled.button`
  color: ${(props) => props.theme.colors.base.grey};
  font-size: 0.9em;
  padding: 0.4em;
  margin: 0.3em;
  border-radius: 5px;
  border: 1px solid ${(props) => props.theme.colors.base.lightGrey};
  background: ${(props) => props.theme.colors.base.veryVeryLightGrey};
  &:hover {
    border: 1px solid ${(props) => props.theme.colors.base.textColor};
    cursor: pointer;
  }

  ${(props) => props.theme.breakpoints.between("xs", "sm")} {
    font-size: 0.8em;
  }
`;

export const StyledshowAllButton = styled.div`
  ${(props) => props.theme.breakpoints.between("xs", "sm")} {
    font-size: 1em;
    margin-top: 0.5em;
  }
`;
export const StyeldShowAllcontainer = styled(Grid)`
  justify-content: flex-end;
`;
export const StyledShowAll = styled.button`
  color: ${(props) => props.theme.colors.base.black};
  border: none;
  font-size: 1em;
  padding: 0.6em;
  border-radius: 5px;
  margin-left: 5px;
  margin-top: 5px;
  background: ${(props) => props.theme.colors.base.lightGrey};
  background: White;
  border: 1px solid ${(props) => props.theme.colors.base.lightGrey};
  cursor: pointer;
  &:hover {
    border: 1px solid ${(props) => props.theme.colors.base.textColor};
    cursor: pointer;
  }
`;

let data: any = {};
let totalElement: number = 0;
let page: number = 0;
let testno: number = 100;

let payload: any = {};
let startCount: number = 0;
let endCount: number = 10;
let endCountMob: number = 100;
let rowSelectedData: any;
let updatedRowData: any;
let updateRowIndex: any;
let auctionProductResult: any;
let seconds: any = "";

let filter: any = [];
let filteredValues: any = "";
let filteredParcelValues: any = "";
let body: any = [];
let auctionName: string = "";
let length: any;
let date: string | string[] = "";
let auctionDate: any;
const columnIndexes = {
  serialNo: 0,
  productId: 1,
  auctionUserId: 2,
  productCode: 4,
  lab: 5,
  certificate: 6,
  description: 7,
  currency: 8,
  remarks: 9,
  notes: 10,
  peicePerCt: 11,
  myLatestBids: 12,
  currentBidPrice: 13,
  noOfBids: 14,
  rowColor: 15,
  exchangeRate: 16,
  noOfBidders: 19,
  currentBidValue: 17,
  hieghestBidValue: 18,
  watched: 20,
  sellerAuctionUserId: 21,
  previousHighestBidder: 23,
  holdPreviousBidder: 24,
};

let details: any;
let SelectedTableData: any;
let auctionStateforPopup: string;
let auctionTenderExtended: boolean = false;
let indexsForBulkBidItems: any = [];
let myLatestBidForProduct: any = [];
let isAuctionUserId: boolean;
let isReadOnlyUser: any;

const initialState = {
  mouseX: null,
  mouseY: null,
};

interface Size {
  width: number | undefined;
  height: number | undefined;
}
let auctionsState: any;
const TendorJewelleryMyBids = (props: IProductViewProps) => {
  const getMuiTheme = () =>
    createTheme({
      overrides: {
        MUIDataTableSelectCell: {
          fixedHeader: {
            background: "white",
          },
          fixedLeft: {
            background: "white",
          },
        },
      },
    });

  const [mybidProducts, setmybidProducts] = useState([]);
  const [openToast, setOpenToast] = useState(false);
  const [showAlertMessage, setShowAlertMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [alertType, setAlertType] = useState("");
  const [apiTimeout, setApiTimeout] = useState(false);
  const [onAction, setOnAction] = useState(false);

  const [userBlock, setUserBlock] = useState(false);
  const [optionValue, setOptionValue] = useState("");
  const [showBidPopup, setShowBidPopup] = useState(false);
  const [isFirstButtonDisable, setisFirstButtonDisable] = useState(false);
  const [showTenderSlider, setshowTenderSlider] = useState(false);
  const [openEndedModal, setOpenEndedModal] = useState(false);
  const [openTenderExtended, setOpenTenderExtended] = useState(false);
  const [uiBoxView, setUiBoxView] = useState(false);
  const [auctionTenderStateTime, setAuctionTenderStateTime] = useState(false);
  const [auctionTenderState, setAuctionTenderState] = useState("");
  const [showBulkBidPopup, setShowBulkBidPopup] = useState(false);
  const [showBulkBidButton, setShowBulkBidButton] = useState(false);
  const [isUserClosedExtendedPopup, setIsUserClosedExtendedPopup] =
    useState(false);
  const [isColorDataFilter, setIsColorDataFilter] = useState(false);
  const [isDataRefresh, setIsDataRefresh] = useState(false);
  const [isTopElementHide, setIsTopElementHide] = useState(false);
  const [expanded, setExpanded] = React.useState<string | false>(false);
  const [isSelected, setIsSelected] = useState<boolean>(false);
  const [openReadOnlyUserToast, setOpenReadOnlyUserToast] = useState(false);
  const [currentProductId, setCurrentProductId] = useState<string>("");
  const [firstTimeExetendPopup, setFirstTimeExetendPopup] =
    useState<boolean>(false);
  const [mouseState, setMouseState] = React.useState<{
    mouseX: null | number;
    mouseY: null | number;
  }>(initialState);
  const [colorMybidsName, setColorMybidsName] = React.useState<string>("");
  const [totalAmount, setTotalAmount] = React.useState(0);
  const [totalAmountLabel, setTotalAmountLabel] = React.useState<string>("");
  const Auth = new AuthService();
  const { t } = props;
  const eventSource: any = useRef<any>();
  const maxRetryCount = 12;
  const countRef = useRef(0);
  const jwlItemPerPageRefmybid = useRef(10);
  const [shouldGetAllData, setShouldGetAllData] = useState(false);
  const dispatch: AppDispatch = useDispatch();
  const bufferTotalPay = useRef(0);
  const selectJwlPageUseRef = useRef(0);
  const usdBufferTotalPay = useRef(0);

  let userCurrencyCode = localStorage.getItem("preferredCurrency");
  let userCurrencySymbol = localStorage.getItem("preferredCurrencySymbol");
  const isGridView: any = useSelector((state: RootState) =>
    selectTenderJwlGridView(state)
  );

  const isMyBidstab: any = useSelector((state: RootState) =>
    JwlIsMyBidstabSelected(state)
  );

  const selectedColor: any = useSelector((state: RootState) =>
    selectedColorFilter(state)
  );

  useEffect(() => {
    setIsLoading(true);
    dispatch(resetTenderGridProductIndexes());
    dispatch(resetTenderjewellerySelectAll());
    //data table api calling
    isReadOnlyUser = localStorage.getItem("isReadOnlyUser");
    isReadOnlyUser = JSON.parse(isReadOnlyUser);
    localStorage.removeItem("dropDownFilterVal");
    localStorage.removeItem("auctionUserId");
    getAuctionEndTime(props.match.params.auctionId);

    getMyLatestBids(props.match.params.auctionId);
    getAllUpdatedData();

    dispatch(setJwlIsMybids({ isMybidstab: true }));
    setTimeout(() => {
      setIsDataRefresh(!isDataRefresh);
    }, 3000);
    return () => {
      if (eventSource.current !== undefined || eventSource.current !== null) {
        if (eventSource.current.close !== undefined) {
          eventSource.current.close();
        }
      }
      dispatch(resetColorFilter());
    };
  }, []);

  useEffect(() => {
    if (shouldGetAllData) {
      getAllUpdatedData();
      setShouldGetAllData(false);
    }
  }, [shouldGetAllData]);

  const getAllUpdatedData = () => {
    if (countRef.current < maxRetryCount) {
      eventSource.current = new EventSource(getBidInfo);
      eventSource.current.onmessage = (event: any) => {
        updatedRowData = JSON.parse(event.data);
        if (updatedRowData.alive) {
          //This will listen only for events
        } else {
          if (props.match.params.auctionId === updatedRowData.auctionId) {
            updateRowIndex = auctionProductResult.findIndex(
              (product: any) => product.perId === updatedRowData.perId
            );
            // setTotalAmount(bufferTotalPay.current + updatedRowData.currentBidPrice);
            const mapping: any = {};
            if (
              auctionProductResult !== undefined &&
              auctionProductResult.length > 0
            ) {
              auctionProductResult.map((items: any) => {
                mapping[items.perId] = {
                  watched: items.watched,
                };
              });
            }

            var updatedArr: any = [];
            if (updateRowIndex !== -1) {
              updatedArr = update(auctionProductResult, {
                $splice: [[updateRowIndex, 1, updatedRowData]],
              });
            }

            const arr = [...updatedArr];

            arr.map((items: any) => {
              if (mapping[items.perId] !== undefined) {
                items.watched = mapping[items.perId].watched;
              }
            });
            auctionProductResult = arr;
            setmybidProducts(auctionProductResult);
            setShouldGetAllData(false);

            //update total amount of user pay
            bufferTotalPay.current =
              bufferTotalPay.current + updatedRowData.liveHighestBidIncreasedBy;
            usdBufferTotalPay.current =
              usdBufferTotalPay.current +
              updatedRowData.liveHighestBidIncreasedByInCurrencies[0].amount;
            //get auction currency symbol
            let { currency } = updatedRowData;
            if (userCurrencyCode !== "JPY") {
              //usre currency code in jpy
              let conversion = new Intl.NumberFormat("us-en").format(
                Math.round(usdBufferTotalPay.current)
              );
              let conversions = new Intl.NumberFormat("us-en").format(
                Math.round(bufferTotalPay.current)
              );
              if (currency.code === "JPY") {
                setTotalAmountLabel(
                  `${updatedRowData.currency.symbol} ${conversions} (${userCurrencySymbol} ${conversion})`
                );
              } else {
                setTotalAmountLabel(
                  `${updatedRowData.currency.symbol} ${conversions}`
                );
              }
            } else {
              let conversion = new Intl.NumberFormat("us-en").format(
                Math.round(usdBufferTotalPay.current)
              );
              let conversions = new Intl.NumberFormat("us-en").format(
                Math.round(bufferTotalPay.current)
              );

              if (currency.code === "JPY") {
                setTotalAmountLabel(
                  `${updatedRowData.currency.symbol} ${conversions}`
                );
              } else {
                setTotalAmountLabel(
                  `${updatedRowData.currency.symbol} ${conversions} (${userCurrencySymbol} ${conversion})`
                );
              }
            }
          }
        }
      };
      eventSource.current.onerror = (err: any) => {
        console.error("EventSource failed:", err);
        countRef.current = countRef.current + 1;
        setShouldGetAllData(true);
      };
    }
  };

  const getAuctionEndTime = (auctionId: string, callBack?: any) => {
    if (!oAuth()) {
      props.history.push("/");
    } else {
      Auth.getRequest(
        `${getAuctionEndTimeUrl}/${auctionId}/end_time`,
        (status: number, response: any) => {
          if (status === 200) {
            setIsLoading(false);
            auctionsState = response.state;
            setFirstTimeExetendPopup(response.tenderExtended);
            getLeftTime(response.endDate);
            setAuctionTenderState(response.state);
            setAuctionTenderStateTime(response.tenderExtended);

            // if (callBack !== undefined) {
            //   callBack(response);
            // }
            if (response.state === "Ended") {
              setOpenEndedModal(true);
            }
          } else if (status === 403) {
            setUserBlock(true);
          } else if (status === 505) {
            setApiTimeout(true);
            setIsLoading(false);
          } else {
            setIsLoading(false);
            setOnAction(false);
            setShowAlertMessage(response[0].message);
            setAlertType("error");
            setOpenToast(true);
          }
        }
      );
    }
  };

  //Note: Get my All LatestBid using this Api
  const getMyLatestBids = (auctionId: string) => {
    if (!oAuth()) {
      props.history.push("/");
    } else {
      Auth.getRequest(
        `${getMyLatestBidsForUser}?auctionId=${auctionId}`,
        (status: number, response: any) => {
          if (status === 200) {
            setIsLoading(false);
            myLatestBidForProduct = response;
            setIsSelected(false);
          } else if (status === 403) {
            setUserBlock(true);
          } else if (status === 505) {
            setApiTimeout(true);
            setIsLoading(false);
          } else {
            setIsLoading(false);
            setOnAction(false);
            setShowAlertMessage("Internal Server Error");
            setAlertType("error");
            setOpenToast(false);
          }
        }
      );
    }
  };

  const getTendorMybidsAucProducts = (
    auctionId: number | string,
    currentPage: number,
    isMob: any
  ) => {
    setOpenToast(false);
    body = [];
    filteredValues = localStorage.getItem("filteredValues");
    filteredValues = JSON.parse(filteredValues);

    if (filteredValues !== undefined) {
      if (filteredValues === null || filteredValues.length === 0) {
        filter = null;
      } else {
        filteredValues.map((item: any, index: number) => {
          if (item.name === "auctionId") {
            filteredValues.splice(index, 1);
          }
        });
        filter = filteredValues;
      }
    } else {
      filteredParcelValues = localStorage.getItem("filteredParcelValues");
      filteredParcelValues = JSON.parse(filteredParcelValues);

      if (filteredParcelValues !== undefined) {
        if (
          filteredParcelValues === null ||
          filteredParcelValues.length === 0
        ) {
          filter = null;
        } else {
          filteredParcelValues.map((item: any, index: number) => {
            if (item.name === "auctionId") {
              filteredParcelValues.splice(index, 1);
            }
          });
          filter = filteredParcelValues;
        }
      }
    }

    getBody(auctionId, currentPage, endCount, isMob);
  };

  const getBody = (
    auctionId: string | number,
    currentPage: number,
    endval: number,
    isMob: boolean
  ) => {
    data = {};

    filteredValues = localStorage.getItem("filteredValues");
    filteredValues = JSON.parse(filteredValues);

    if (
      localStorage.getItem("currentStart") !== null &&
      localStorage.getItem("currentStart") !== "0" &&
      localStorage.getItem("currentStart") !== undefined
    ) {
      let savedCount: any = localStorage.getItem("currentStart");
      startCount = parseInt(savedCount);
      selectJwlPageUseRef.current = startCount;
    } else {
      startCount = 0;
      selectJwlPageUseRef.current = startCount;
    }

    if (localStorage.getItem("tenderitemsPerPage") !== null) {
      let savedCount: any = localStorage.getItem("tenderitemsPerPage");
      endCount = parseInt(savedCount);
      jwlItemPerPageRefmybid.current = endCount;
    } else {
      endCount = 10;
      jwlItemPerPageRefmybid.current = 10;
    }

    //handle drop downfilter value

    if (
      localStorage.getItem("dropDownFilterVal") !== undefined &&
      localStorage.getItem("dropDownFilterVal") !== null
    ) {
      var tempArr = localStorage.getItem("dropDownFilterVal");
      if (tempArr !== null) var dropDownValues = JSON.parse(tempArr);
      var property = dropDownValues[0].property;
      var direction = dropDownValues[0].direction;
    }

    if (
      filter === null &&
      (filteredValues == null ||
        filteredValues === undefined ||
        filteredValues === "null" ||
        filteredValues.length === 0)
    ) {
      payload = {
        filters: {
          and: [
            {
              match: "exact",
              name: "auctionId",
              value: auctionId,
            },
            {
              match: "exact",
              name: "parcelType",
              value: "Jewellery",
            },
          ],
        },
        page: {
          start: isMob ? startCount : 0,
          count: isMob ? endCount : isMyBidstab ? 5000 : endval,
          sort: {
            orders: [
              {
                property:
                  property !== null && property !== undefined
                    ? property
                    : "createdDate",
                direction:
                  direction !== null && direction !== undefined
                    ? direction
                    : "DESC",
              },
            ],
          },
        },
      };
    } else {
      body = filteredValues ? filteredValues : filter;
      body.map((item: any, index: number) => {
        if (item.name === "auctionId") {
          body.splice(index, 1);
        }
      });

      payload = {
        filters: {
          or: body,
          and: [
            {
              match: "exact",
              name: "auctionId",
              value: props.match.params.auctionId,
            },
          ],
        },
        page: {
          start: startCount,
          count: isMob ? endCount : isMyBidstab ? 5000 : endval,
          sort: {
            orders: [
              {
                property:
                  property !== null && property !== undefined
                    ? property
                    : "createdDate",
                direction:
                  direction !== null && direction !== undefined
                    ? direction
                    : "DESC",
              },
            ],
          },
        },
      };
    }

    let val = localStorage.getItem("optionValue");
    if (val !== "" && val !== "null" && val != null) {
      setOptionValue(val);
      payload = {
        filters: {
          or: [
            {
              match: "anywhere",
              name: "remarks",
              value: val,
            },
          ],
          and: [
            {
              match: "exact",
              name: "auctionId",
              value: props.match.params.auctionId,
            },
          ],
        },
        page: {
          start: startCount,
          count: isMob ? endCount : isMyBidstab ? 5000 : endval,
          sort: {
            orders: [
              {
                property: "createdDate",
                direction: "DESC",
              },
            ],
          },
        },
      };
    }
    callApi(payload);
  };

  const handleBidClick = (tableData: any) => {
    rowSelectedData = tableData.rowData;
    rowSelectedData = tableData.rowData;
    SelectedTableData = tableData.tableData;
    getProductsDetails(mybidProducts);
    setshowTenderSlider(true);
  };

  const getProductsDetails = (product: any) => {
    length = mybidProducts.length;
    product.map((items: any, index: any) => {
      if (items.perId === rowSelectedData[columnIndexes.productId]) {
        details = index;
      }
    });
    return details;
  };

  // Tender mobile ui
  const getBoxIndex = (boxIndex: any) => {
    length = mybidProducts.length;
    details = boxIndex;
    setshowTenderSlider(true);
  };

  const callApi = (payload: any) => {
    if (!oAuth()) {
      props.history.push("/");
    } else {
      Auth.postRequest(
        `${auctionTendorMyBids}?auctionId=${props.match.params.auctionId}&rowColorState=${selectedColor}`,
        payload,
        (status: any, response: any) => {
          setIsLoading(false);
          if (status === 200) {
            auctionName = response?.results[0]?.auctionName;
            totalElement = response.totalElements;
            auctionProductResult = response.results;
            if (response.results.length > 0) {
              auctionDate = response?.results[0]?.auctionStartDate;
              date = auctionDate.split(" ", 2);
            }
            const requestData: any = [];
            let totalpay = 0;
            let usdTotalPay = 0;
            //calculate total sum of current Bid Price
            if (
              response.additionalData !== undefined &&
              response.results.length !== 0
            ) {
              let { totalAmount, totalAmountUSD, totalAmountJPY } =
                response.additionalData;
              let { currency } = response.results[0];
              totalpay = totalAmount;
              //get auction currency symbol
              if (userCurrencyCode !== "JPY") {
                usdTotalPay = totalAmountUSD;
                if (currency.code === "JPY") {
                  let conversion = new Intl.NumberFormat("us-en").format(
                    Math.round(totalAmountUSD)
                  );
                  let conversions = new Intl.NumberFormat("us-en").format(
                    Math.round(totalAmount)
                  );
                  setTotalAmountLabel(
                    `${currency.symbol} ${conversions} (${userCurrencySymbol} ${conversion})`
                  );
                } else {
                  let conversions = new Intl.NumberFormat("us-en").format(
                    Math.round(totalAmount)
                  );
                  setTotalAmountLabel(`${currency.symbol} ${conversions}`);
                }
              } else {
                if (currency.code === "JPY") {
                  let conversions = new Intl.NumberFormat("us-en").format(
                    Math.round(totalAmount)
                  );
                  setTotalAmountLabel(`${currency.symbol} ${conversions}`);
                } else {
                  usdTotalPay = totalAmountJPY;
                  let conversion = new Intl.NumberFormat("us-en").format(
                    Math.round(totalAmountJPY)
                  );
                  let conversions = new Intl.NumberFormat("us-en").format(
                    Math.round(totalAmount)
                  );
                  setTotalAmountLabel(
                    `${currency.symbol} ${conversions} (${userCurrencySymbol} ${conversion})`
                  );
                }
              }
            } else {
              setTotalAmountLabel(`-`);
              setmybidProducts(response.results);
            }

            bufferTotalPay.current = totalpay;
            usdBufferTotalPay.current = usdTotalPay;
            setTotalAmount(totalpay);

            setmybidProducts(response.results);

            for (var i = 0; i < response.totalElements; i++) {
              var obj = response.results[i];
              const { auctionUserId, rowColor, previousHighestBidder } = obj;
              if (previousHighestBidder === undefined) {
                if (auctionUserId !== props.match.params.auctionUserId) {
                  obj["sortingColorCode"] = 113;
                  obj["colorFilter"] = "WHITE";
                } else {
                  if (rowColor === "#FFEB9C") {
                    obj["sortingColorCode"] = 112;
                    obj["colorFilter"] = "ORANGE";
                  } else {
                    obj["sortingColorCode"] = 111;
                    obj["colorFilter"] = "PINK";
                  }
                }
              } else {
                if (
                  props.match.params.auctionUserId === previousHighestBidder
                ) {
                  obj["sortingColorCode"] = 111;
                  obj["colorFilter"] = "PINK";
                } else {
                  if (rowColor === "#FFEB9C") {
                    obj["sortingColorCode"] = 112;
                    obj["colorFilter"] = "ORANGE";
                  } else {
                    obj["sortingColorCode"] = 111;
                    obj["colorFilter"] = "PINK";
                  }
                }
              }
              requestData.push(obj);
            }
            setmybidProducts(requestData);
            setColorMybidsName(selectedColor);
          } else if (status === 403) {
            setUserBlock(true);
          } else if (status === 505) {
            setApiTimeout(true);
            setOnAction(false);
          } else if (status === 404) {
            setIsLoading(false);
            setOnAction(false);
            setShowAlertMessage(`${t("common:invalidRequest")}`);
            setAlertType("error");
            setOpenToast(true);
          } else {
            setIsLoading(false);
            setOnAction(false);
            setShowAlertMessage(response[0].message);
            setAlertType("error");
            setOpenToast(true);
          }
        }
      );
    }
  };

  // Tender bulk bid popup
  const bulkBidPopupHandler = () => {
    setShowBulkBidPopup(true);
  };

  const handleBtnValue = (
    values: number,
    currentBidPrice: any,
    productId: any,
    myBidValues: any
  ) => {
    var data = [
      {
        bidIncreasedBy: values,
        bidPrice: currentBidPrice,
        auctionUserId: props.match.params.auctionUserId,
        auctionId: props.match.params.auctionId,
        productId: productId,
      },
    ];
    let updateRowIndex = myLatestBidForProduct.findIndex(
      (product: any) => product.productId === myBidValues.productId
    );
    if (updateRowIndex === -1) {
      var myLatestBidForProductObjectData: any = [
        ...myLatestBidForProduct,
        myBidValues,
      ];
      myLatestBidForProduct = myLatestBidForProductObjectData;
    } else {
      var updatedArray = update(myLatestBidForProduct, {
        $splice: [[updateRowIndex, 1, myBidValues]],
      });
      myLatestBidForProduct = updatedArray;
    }
    bidProduct(data);
  };

  const bulkBidHandler = (values: any[], myBidBulkValues: any) => {
    myLatestBidForProduct = myBidBulkValues;
    bidProduct(values);
    onGridSelectionChange(0);
    PubSub.publish("resetGridBoxIndex", []);
    dispatch(resetTenderGridProductIndexes());
    dispatch(resetTenderjewellerySelectAll());
  };

  const bidProduct = (payloadBid: any) => {
    if (!oAuth()) {
      props.history.push("/");
    } else {
      Auth.postRequest(
        tendorBidUrl,
        payloadBid,
        (status: any, response: any) => {
          if (status === 200) {
            setShowBidPopup(false);
            setIsDataRefresh(!isDataRefresh);
            getMyLatestBids(props.match.params.auctionId);
          } else if (status === 403) {
            setUserBlock(true);
            setShowBidPopup(false);
          } else if (status === 505) {
            setApiTimeout(true);
            setOnAction(false);
            setShowBidPopup(false);
          } else if (status === 404) {
            setIsLoading(false);
            setOnAction(false);
            setShowAlertMessage(`${t("common:invalidRequest")}`);
            setAlertType("error");
            setOpenToast(true);
            setShowBidPopup(false);
          } else {
            setIsLoading(false);
            setOnAction(false);
            setShowAlertMessage(response[0].message);
            setAlertType("error");
            setOpenToast(true);
            setShowBidPopup(false);
          }
        }
      );
    }
  };

  const getTableBodyHeight = () => {
    var h = window.innerHeight;
    let heightOfInnerTable = h - 250;
    if (mybidProducts.length > 2) {
      return `${heightOfInnerTable}px`;
    } else {
      return `auto`;
    }
  };

  const options: MUIDataTableOptions = {
    filter: true,
    download: "false",
    print: "false",
    viewColumns: "false",
    count: totalElement,
    // page: page,
    pagination: false,
    serverSide: false,
    search: true,
    sort: true,
    rowsPerPage: endCount,
    rowsPerPageOptions: [0],
    selectableRows: "multiple",
    selectableRowsHeader: true,
    selectableRowsOnClick: false,
    isRowSelectable: (dataIndex: any) => {
      const disableRowIndexsArray = getDisableRowIndex();
      return disableRowIndexsArray.includes(dataIndex) ? false : true;
    },
    customToolbarSelect: () => {
      return (
        <div className="mailIconDiv">
          <IconButton color="primary">
            <i className="zmdi zmdi-email"></i>
          </IconButton>
        </div>
      );
    },
    onChangePage: (currentPage: number) => {
      getTendorMybidsAucProducts(
        props.match.params.auctionId,
        currentPage,
        false
      );
    },

    onSearchChange: () => { },
    setRowProps: (row: any) => {
      if (row[columnIndexes.previousHighestBidder] === undefined) {
        if (row[columnIndexes.holdPreviousBidder] === undefined) {
          if (
            row[columnIndexes.auctionUserId] !==
            props.match.params.auctionUserId
          ) {
            return { style: { background: "white" } };
          } else {
            return { style: { background: row[columnIndexes.rowColor] } };
          }
        } else {
          if (
            props.match.params.auctionUserId ===
            row[columnIndexes.holdPreviousBidder]
          ) {
            return { style: { background: "#ffeb9c" } };
          } else {
            return { style: { background: row[columnIndexes.rowColor] } };
          }
        }
      } else {
        if (
          props.match.params.auctionUserId ===
          row[columnIndexes.previousHighestBidder]
        ) {
          return { style: { background: "#FBE4D5" } };
        } else {
          return { style: { background: row[columnIndexes.rowColor] } };
        }
      }
    },
    onRowSelectionChange: (
      currentRowsSelected: any,
      allRowsSelected: any,
      rowsSelected: any
    ) => {
      indexsForBulkBidItems = rowsSelected;
      setOpenToast(false);
      indexsForBulkBidItems.map((indexs: any) => {
        let {
          sellerAuctionUserId,
          previousHighestBidder,
          auctionUserId,
          holdPreviousBidder,
        } = mybidProducts[indexs];
        if (sellerAuctionUserId === props.match.params.auctionUserId) {
          return { ...options, isRowSelectable: "false" };
        } else if (previousHighestBidder !== undefined) {
          if (props.match.params.auctionUserId === previousHighestBidder) {
            return { ...options, isRowSelectable: "false" };
          }
        } else if (holdPreviousBidder !== undefined) {
          if (props.match.params.auctionUserId === holdPreviousBidder) {
            return { ...options, isRowSelectable: "false" };
          }
        } else if (auctionUserId === props.match.params.auctionUserId) {
          return { ...options, isRowSelectable: "false" };
        }
      });
      if (indexsForBulkBidItems.length >= 0) {
        setShowBulkBidButton(true);
      } else {
        setShowBulkBidButton(false);
      }
      if (indexsForBulkBidItems.length === 0) {
        setShowBulkBidButton(false);
      }
      if (indexsForBulkBidItems.length > 10) {
        setShowAlertMessage(
          `${t("common:Tender:validation:productSelection")}`
        );
        setAlertType("error");
        setOpenToast(true);
      }
    },
    tableBodyHeight: getTableBodyHeight(),
    textLabels: {
      body: {
        noMatch: `${t("common:preview:noProductFound")}`,
      },
    },
  };

  const onGridSelectionChange = (rowsSelected: any) => {
    indexsForBulkBidItems = rowsSelected;
    setOpenToast(false);
    if (indexsForBulkBidItems.length >= 0) {
      setShowBulkBidButton(true);
    } else {
      setShowBulkBidButton(false);
    }
    if (indexsForBulkBidItems.length === 0) {
      setShowBulkBidButton(false);
    }
    if (indexsForBulkBidItems.length > 10) {
      setShowAlertMessage(`${t("common:Tender:validation:productSelection")}`);
      setAlertType("error");
      setOpenToast(true);
    }
  };

  const boxColor = (items: any) => {
    const {
      auctionUserId,
      rowColor,
      previousHighestBidder,
      holdPreviousBidder,
    } = items;
    if (previousHighestBidder === undefined) {
      if (holdPreviousBidder === undefined) {
        if (auctionUserId !== props.match.params.auctionUserId) {
          return "white";
        } else {
          return rowColor;
        }
      } else {
        if (props.match.params.auctionUserId === holdPreviousBidder) {
          return "#ffeb9c";
        } else {
          return rowColor;
        }
      }
    } else {
      if (props.match.params.auctionUserId === previousHighestBidder) {
        return "#FBE4D5";
      } else {
        return rowColor;
      }
    }
  };
  const getDisableRowIndex = () => {
    return mybidProducts.map((items: any, index: number) => {
      if (items.sellerAuctionUserId === props.match.params.auctionUserId) {
        return index;
      } else if (items.previousHighestBidder !== undefined) {
        if (props.match.params.auctionUserId === items.previousHighestBidder) {
          return index;
        }
      } else if (items.holdPreviousBidder !== undefined) {
        if (props.match.params.auctionUserId === items.holdPreviousBidder) {
          return index;
        }
      } else if (items.auctionUserId === props.match.params.auctionUserId) {
        return index;
      }
    });
  };

  const columns: MUIDataTableColumnDef[] = [
    {
      name: "serialNo",
      label: "Serial No",
      options: {
        filter: true,
        sort: true,
        display: true,
        filterType: "textField",
        sortThirdClickReset: true,
        sortDescFirst: true,
      },
    },
    {
      name: "perId",
      label: "Product Id",
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },
    {
      name: "auctionUserId",
      label: "Auction User Id",
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },
    {
      name: "",
      label: `${t("common:Tender:tableColumnNames:ActionsTender")}`,
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value: any, tableMeta: any) => {
          return (
            <div
              style={{
                display: "flex",
                gridGap: "10px",
                justifyContent: "center",
              }}
            >
              <div
                title={`Note`}
                style={{ cursor: "pointer" }}
                onClick={() =>
                  openProductDetail(
                    props.match.params.auctionId,
                    tableMeta.rowData[1]
                  )
                }
              >
                <FontAwesomeIcon
                  icon={faEditProps}
                  style={{ color: "#014a99" }}
                />
              </div>
              <div
                title={`Add Product into Wishlist`}
                style={{ cursor: "pointer" }}
              >
                {isReadOnlyUser ? (
                  <FontAwesomeIcon
                    icon={faHeartProps}
                    style={{ color: "gray" }}
                    onClick={() => {
                      renderReadOnlyUserToast(
                        tableMeta.rowData[columnIndexes.sellerAuctionUserId]
                      );
                    }}
                  />
                ) : (
                  <>
                    {tableMeta.rowData[columnIndexes.sellerAuctionUserId] !==
                      props.match.params.auctionUserId ? (
                      <>
                        {getWatchedProduct(
                          tableMeta.rowData[columnIndexes.watched],
                          tableMeta.rowData[columnIndexes.productId],
                          props.match.params.auctionId,
                          tableMeta.rowData[1]
                        )}
                      </>
                    ) : (
                      <FontAwesomeIcon
                        icon={faHeartProps}
                        style={{ color: "gray" }}
                        onClick={() => {
                          renderReadOnlyUserToast(
                            tableMeta.rowData[columnIndexes.sellerAuctionUserId]
                          );
                        }}
                      />
                    )}
                  </>
                )}
              </div>
              <div
                title={`Share Product`}
                style={{ cursor: "pointer" }}
                onClick={() =>
                  shareButtonAction(tableMeta.rowData[columnIndexes.productId])
                }
              >
                <FontAwesomeIcon
                  icon={faShareSquareProps}
                  style={{ color: "#014a99" }}
                />
              </div>
            </div>
          );
        },
      },
    },
    {
      name: "code",
      label: `${t("common:Tender:tableColumnNames:sku")}`,
      options: {
        filter: true,
        sort: false,
        filterType: "textField",
        customBodyRender: (value: any, tableMeta: any) => {
          return (
            <span
              className="linkCss"
              onClick={() =>
                openProductDetail(
                  props.match.params.auctionId,
                  tableMeta.rowData[1]
                )
              }
              onContextMenu={(event: any) =>
                rightClickEvent(event, tableMeta.rowData[1])
              }
            >
              {value}
            </span>
          );
        },
      },
    },
    {
      name: "lab",
      label: `${t("common:Tender:tableColumnNames:lab")}`,
      options: {
        filter: false,
        sort: true,
        customBodyRender: (value: any, tableMeta: any) => {
          if (
            value !== "AGT" &&
            value !== "agt" &&
            value !== "" &&
            value !== undefined
          ) {
            return (
              <span
                className="linkCss"
                onClick={() =>
                  openJewelleryCertificateLinkPopup(
                    value,
                    tableMeta.rowData[columnIndexes.certificate]
                  )
                }
              >
                {value}
              </span>
            );
          } else {
            return <span>{value}</span>;
          }
        },
      },
    },
    {
      name: "certificate",
      label: `${t("common:Tender:tableColumnNames:certification")}`,
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },
    {
      name: "jewelleryDetails",
      label: `${t("common:Tender:tableColumnNames:description")}`,
      options: {
        filter: false,
        sort: false,
        filterType: "textField",
        customBodyRender: (value: any) => {
          return (
            <EllipsisText
              text={getDescription(value)}
              length={50}
              tail={"..."}
            />
          );
        },
      },
    },
    {
      name: "currency",
      label: "currency",
      options: {
        display: false,
        filter: false,
        sort: false,
        customBodyRender: (value: any) => {
          return <div>{value.code}</div>;
        },
      },
    },
    {
      name: "remarks",
      label: `${t("common:Tender:tableColumnNames:remark")}`,
      options: {
        filter: true,
        sort: false,
        filterType: "textField",
        customBodyRender: (value: any, tableMeta: any) => {
          return (
            <EllipsisText
              text={getRemarks(tableMeta.rowData[columnIndexes.remarks])}
              length={50}
              tail={"..."}
            />
          );
        },
      },
    },
    {
      name: "notes",
      label: `${t("common:Tender:tableColumnNames:notes")}`,
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },
    {
      name: "caratMinimumPrice",
      label: `${t("common:Tender:tableColumnNames:jewelleryPrice")}`,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value: any, tableMeta: any) => {
          return (
            <div>
              {convertedValue(
                tableMeta.rowData[columnIndexes.currency],
                value,
                tableMeta.rowData[columnIndexes.exchangeRate][0].rate
              )}
            </div>
          );
        },
      },
    },
    {
      name: "myLatestBid",
      label: `${t("common:Tender:tableColumnNames:placeBid")}`,
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value: any, tableMeta: any) => {
          return (
            <>
              {isDataRefresh ? (
                <div>
                  {handelMyBidsLabel(
                    myLatestBidForProduct,
                    tableMeta.rowData[columnIndexes.productId],
                    tableMeta.rowData[columnIndexes.currency],
                    tableMeta.rowData[columnIndexes.exchangeRate][0].rate
                  )}
                </div>
              ) : (
                <div>
                  {handelMyBidsLabel(
                    myLatestBidForProduct,
                    tableMeta.rowData[columnIndexes.productId],
                    tableMeta.rowData[columnIndexes.currency],
                    tableMeta.rowData[columnIndexes.exchangeRate][0].rate
                  )}
                </div>
              )}
              {getBidNowButtonDisable(
                tableMeta.rowData[columnIndexes.sellerAuctionUserId],
                props.match.params.auctionUserId,
                tableMeta.rowData[columnIndexes.auctionUserId],
                tableMeta,
                getReturnMyLatestStoredBid(
                  myLatestBidForProduct,
                  tableMeta.rowData[columnIndexes.productId]
                ),
                tableMeta.rowData[columnIndexes.currentBidPrice],
                tableMeta.rowData[columnIndexes.productId],
                tableMeta.rowData[columnIndexes.previousHighestBidder],
                tableMeta.rowData[columnIndexes.holdPreviousBidder]
              )}
            </>
          );
        },
      },
    },
    {
      name: "currentBidPrice",
      label: `${t("common:Tender:tableColumnNames:liveHighestBid")}`,
      options: {
        filter: false,
        sort: true,
        display: true,
        customBodyRender: (value: any, tableMeta: any) => {
          return (
            <div>
              {convertedValue(
                tableMeta.rowData[columnIndexes.currency],
                value,
                tableMeta.rowData[columnIndexes.exchangeRate][0].rate
              )}
            </div>
          );
        },
      },
    },
    {
      name: "noOfBidders",
      label: `${t("common:newCommanTrans:noOfBiddersBids")}`,
      options: {
        filter: true,
        sort: false,
        customBodyRender: (value: any, tableMeta: any) => {
          return (
            <div>
              {getNoOfBiddersAndNoOfBids(
                tableMeta.rowData[columnIndexes.noOfBids],
                tableMeta.rowData[columnIndexes.noOfBidders]
              )}
            </div>
          );
        },
      },
    },

    {
      name: "rowColor",
      label: "Bid Color",
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },
    {
      name: "exchangeRates",
      label: "Exchange Rate",
      options: {
        filter: false,
        sort: false,
        display: false,
        customBodyRender: (value: any) => {
          return <div>{value[0].rate}</div>;
        },
      },
    },
    {
      name: "myLatestBid",
      label: "",
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },
    {
      name: "currentBidPrice",
      label: "",
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },
    {
      name: "noOfBids",
      label: "",
      options: {
        filter: true,
        sort: false,
        display: false,
      },
    },
    {
      name: "watched",
      label: "",
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },
    {
      name: "sellerAuctionUserId",
      label: "",
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },
    {
      name: "tenderSecondHighestBid",
      label: `${t("common:Tender:tableColumnNames:liveHighestBid")}`,
      options: {
        filter: false,
        sort: false,
        display: false,
        customBodyRender: (value: any, tableMeta: any) => {
          return (
            <div>
              {convertedValue(
                tableMeta.rowData[columnIndexes.currency],
                value,
                tableMeta.rowData[columnIndexes.exchangeRate][0].rate
              )}
            </div>
          );
        },
      },
    },
    {
      name: "previousHighestBidder",
      label: "",
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },
    {
      name: "holdPreviousBidder",
      label: "",
      options: {
        filter: false,
        sort: false,
        display: false,
      },
    },
  ];

  const renderAutomaticBidPopup = (data: any) => {
    const rediractProductId: any = localStorage.getItem(
      "currentJewelleryProductIdOfBidNow"
    );

    if (rediractProductId !== null) {
      const indexOfProduct = mybidProducts.findIndex(
        (item: any) => item.perId === rediractProductId
      );
      rowSelectedData = data.rowData;
      SelectedTableData = data.tableData;
      details = indexOfProduct;
      length = mybidProducts.length;
      if (details !== -1) {
        setshowTenderSlider(true);
      }
      setTimeout(() => {
        localStorage.removeItem("currentJewelleryProductIdOfBidNow");
      }, 3000);
    }
  };

  const renderAutomaticBidPopupInMobile = (data: any) => {
    const rediractProductId: any = localStorage.getItem(
      "currentJewelleryProductIdOfBidNow"
    );
    if (rediractProductId !== null) {
      const indexOfProduct = mybidProducts.findIndex(
        (item: any) => item.perId === rediractProductId
      );
      rowSelectedData = data;
      SelectedTableData = mybidProducts;
      details = indexOfProduct;
      length = mybidProducts.length;
      if (details !== -1) {
        setshowTenderSlider(true);
      }
      setTimeout(() => {
        localStorage.removeItem("currentJewelleryProductIdOfBidNow");
      }, 3000);
    }
  };

  const getBidNowButtonDisable = (
    sellerId: any,
    auctionUserIdForProduct: any,
    tableAuctionUserId: any,
    tableDataForUIBox: any,
    myBidsForProduct: any,
    currentBidPriceForProduct: any,
    currentproductId: any,
    previousBidderId: any,
    holdPreviousBidder: any
  ) => {
    renderAutomaticBidPopup(tableDataForUIBox);
    if (isReadOnlyUser) {
      return (
        <StyledBtnContainer
          onClick={() => {
            renderReadOnlyUserToast(sellerId);
          }}
        >
          <StyledButtonGray>
            {t("common:inquiry:button:bidNow")}
          </StyledButtonGray>
        </StyledBtnContainer>
      );
    } else {
      if (sellerId === auctionUserIdForProduct) {
        return (
          <StyledBtnContainer>
            <StyledButtonGray>
              {t("common:inquiry:button:bidNow")}
            </StyledButtonGray>
          </StyledBtnContainer>
        );
      } else if (holdPreviousBidder !== undefined) {
        if (props.match.params.auctionUserId === holdPreviousBidder) {
          return (
            <StyledBtnContainer>
              <StyledButtonGray>
                {t("common:inquiry:button:bidNow")}
              </StyledButtonGray>
            </StyledBtnContainer>
          );
        } else {
          return (
            <StyledBtnContainer>
              <StyledButton onClick={() => handleBidClick(tableDataForUIBox)}>
                {t("common:inquiry:button:bidNow")}
              </StyledButton>
            </StyledBtnContainer>
          );
        }
      } else if (previousBidderId !== undefined) {
        if (props.match.params.auctionUserId === previousBidderId) {
          return (
            <StyledBtnContainer>
              <StyledButtonGray>
                {t("common:inquiry:button:bidNow")}
              </StyledButtonGray>
            </StyledBtnContainer>
          );
        } else {
          return (
            <StyledBtnContainer>
              <StyledButton onClick={() => handleBidClick(tableDataForUIBox)}>
                {t("common:inquiry:button:bidNow")}
              </StyledButton>
            </StyledBtnContainer>
          );
        }
      } else if (tableAuctionUserId === props.match.params.auctionUserId) {
        return (
          <StyledBtnContainer>
            <StyledButtonGray>
              {" "}
              {t("common:inquiry:button:bidNow")}
            </StyledButtonGray>
          </StyledBtnContainer>
        );
      } else {
        return (
          <StyledBtnContainer>
            <StyledButton onClick={() => handleBidClick(tableDataForUIBox)}>
              {t("common:inquiry:button:bidNow")}
            </StyledButton>
          </StyledBtnContainer>
        );
      }
    }
  };

  const handelMyBidsLabel = (
    myStoredBids: any,
    currentProductId: any,
    currency: any,
    exchangeRate: any
  ) => {
    const Obj = myLatestBidForProduct.filter(
      (item: any) => item.productId === currentProductId
    );

    const mybidPriceforProducts = Obj.map((item: any) => {
      return item.productId;
    });

    return getMyLatestStoredBids(
      myLatestBidForProduct,
      currentProductId,
      currency,
      exchangeRate,
      mybidPriceforProducts
    );
  };

  const getMyLatestStoredBids = (
    productBids: any,
    productIdFromData: any,
    currencyCodeVal: any,
    exchangeRate: any,
    otherID: any
  ) => {
    if (otherID !== undefined) {
      if (otherID[0] === productIdFromData) {
        return productBids?.map((items: any) => {
          const { productId, myLatestBid } = items;
          if (productId === productIdFromData) {
            let userCurrencyCode = localStorage.getItem("preferredCurrency");
            let userCurrencySymbol = localStorage.getItem(
              "preferredCurrencySymbol"
            );
            if (userCurrencyCode != currencyCodeVal.code) {
              let conversion = new Intl.NumberFormat("us-en").format(
                Math.round(myLatestBid * exchangeRate)
              );
              let conversions = new Intl.NumberFormat("us-en").format(
                Math.round(myLatestBid)
              );
              return `${currencyCodeVal.symbol} ${conversions} (${userCurrencySymbol} ${conversion})`;
            } else {
              let conversions = new Intl.NumberFormat("us-en").format(
                Math.round(myLatestBid)
              );
              return `${userCurrencySymbol} ${conversions}`;
            }
          }
        });
      } else {
        return "0";
      }
    }
  };

  //get Watched Product
  const getWatchedProduct = (
    watched: any,
    productId: any,
    auctionId: any,
    serialNo: any
  ) => {
    if (watched === true) {
      return (
        <FontAwesomeIcon
          icon={faHeartProps}
          style={{ color: "red", cursor: "pointer" }}
          onClick={() => removeFromWatchlist(productId, auctionId)}
        />
      );
    } else {
      return (
        <FontAwesomeIcon
          icon={faHeartProps}
          style={{ color: "gray" }}
          onClick={() => addToWatchList(productId, auctionId)}
        />
      );
    }
  };

  const shareButtonAction = (perId: any) => {
    const { t } = props;
    let languageCode =
      localStorage.getItem("language") === "EN"
        ? "en"
        : localStorage.getItem("language") === "zh_CN"
          ? "zh_CN"
          : "jp";
    copy(
      `${window.location.hostname}/${languageCode}/product/jewellery/${perId}/${date[0]}/detail`
    );
    setAlertType("success");
    setOpenToast(true);
    setShowAlertMessage(`${t("common:preview:linkCopied")}`);
    setTimeout(() => {
      setOpenToast(false);
    }, 2000);
  };

  const getNoOfBiddersAndNoOfBids = (noOfBidders: any, noOfBids: any) => {
    return `${noOfBidders}/${noOfBids}`;
  };

  const getRemarks = (remarks: any) => {
    if (remarks !== "" && remarks !== undefined && remarks !== null) {
      return remarks;
    } else {
      return "";
    }
  };

  const openProductDetail = (auctionId: string, perId: string) => {
    localStorage.setItem("auctionUserId", props.match.params.auctionUserId);
    props.history.push(
      `/preview/tender/jewellery/details/${auctionId}/${perId}/${date[0]}?isAuction=true&uniqid=${props.match.params.auctionUserId}`
    );
  };

  const openDetailsView = (
    auctionId: string,
    perId: string,
    auctionDate: string
  ) => {
    localStorage.setItem("auctionUserId", props.match.params.auctionUserId);
    const language = localStorage.getItem("language");

    const languageCode =
      language === "EN" ? "en" : language === "zh_CN" ? "zh_CN" : "jp";
    window.open(
      `/${languageCode}/preview/tender/jewellery/details/${auctionId}/${perId}/${date[0]}?isAuction=true&uniqid=${props.match.params.auctionUserId}`,
      "_blank"
    );
  };

  const rightClickEvent = (
    event: React.MouseEvent<HTMLDivElement>,
    productId: string
  ) => {
    event.preventDefault();
    setMouseState({
      mouseX: event.clientX - 2,
      mouseY: event.clientY - 4,
    });
    setCurrentProductId(productId);
  };

  const handleClose = () => {
    setMouseState(initialState);
  };

  const getDescription = (jewelleryDetails: any) => {
    var jewelleryType: string = "";
    var jewelleryCondition: string = "";
    var jewelleryDescription: string = "";
    if (jewelleryDetails !== undefined && jewelleryDetails !== null) {
      if (
        jewelleryDetails.jewelleryType !== undefined &&
        jewelleryDetails.jewelleryType !== null
      ) {
        jewelleryType = jewelleryDetails.jewelleryType;
      } else {
        jewelleryType = "";
      }

      if (
        jewelleryDetails.jewelleryCondition !== undefined &&
        jewelleryDetails.jewelleryCondition !== null
      ) {
        jewelleryCondition = jewelleryDetails.jewelleryCondition;
      } else {
        jewelleryCondition = "";
      }

      if (
        jewelleryDetails.jewelleryDescription !== undefined &&
        jewelleryDetails.jewelleryDescription !== null
      ) {
        jewelleryDescription = jewelleryDetails.jewelleryDescription;
      } else {
        jewelleryDescription = "";
      }
    }

    return (
      jewelleryType + " " + jewelleryCondition + " " + jewelleryDescription
    );
  };

  const closeModal = () => {
    Auth.logout();
    props.history.replace("/");
  };

  const removeFromWatchlist = (
    productId: string | number,
    auctionId: string | number
  ) => {
    setOnAction(true);
    setOpenToast(false);
    if (Auth.loggedIn() === null) {
      props.history.push("/");
    } else {
      Auth.postRequest(
        `${productUrl}/${auctionId}/${productId}/unwatch`,
        "payload",
        (status: any, response: any) => {
          if (status === 200) {
            callApi(payload);
            setIsLoading(false);
            setOnAction(false);
            setShowAlertMessage(response.data.message);
            setAlertType("success");
            setOpenToast(true);
          } else if (status === 403) {
            setUserBlock(true);
          } else if (status === 404) {
            setIsLoading(false);
            setShowAlertMessage(`${t("common:invalidRequest")}`);
            setOnAction(false);
            setAlertType("error");
            setOpenToast(true);
          } else if (status === 505) {
            setApiTimeout(true);
            setOnAction(false);
          } else {
            setIsLoading(false);
            setOnAction(false);
            setShowAlertMessage(response[0].message);
            setAlertType("error");
            setOpenToast(true);
          }
        }
      );
    }
  };

  const exportExcel = () => {
    let exportProductIds: any = mybidProducts.map((item: any) => {
      return item.perId;
    });
    Auth.postRequestForExcel(
      `${productDownload}?auctionId=${props.match.params.auctionId}&auctionType=Jewellery&auctionProductsType=mybids`,
      { ids: exportProductIds.join() },
      (status: any, response: any) => {
        if (status === 200) {
          if (response !== undefined) {
            const url = window.URL.createObjectURL(
              new Blob([response], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
              })
            );
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", `Products.xlsx`);
            document.body.appendChild(link);
            link.click();
          }
        } else {
          //todo
        }
      }
    );
  };

  const ShowAllProduct = (auctionId: string | number) => {
    if (uiBoxView) {
      getBody(auctionId, 0, 1000, true);
    } else {
      getBody(auctionId, 0, 1000, false);
    }
  };

  const getLeftTime = (startDate: any) => {
    let date: string | null = "";
    let time: string | null = "";
    let hour: any = "";
    let minutes: any = "";
    let timeDifference: any = "";
    let timezone: any = "";

    if (startDate !== null || startDate !== undefined) {
      let previewTime = moment.utc(startDate);
      if (timezone !== null) {
        timezone = localStorage.getItem("timezoneName");
      }
      if (previewTime !== null || previewTime !== undefined) {
        let result = moment.tz(previewTime, timezone);
        let resultFormatter = result.format();
        if (resultFormatter !== "Invalid date") {
          let splitDateTime = resultFormatter.split("T", 2);
          let splitTime: any = "";
          if (splitDateTime[1].includes("+")) {
            splitTime = splitDateTime[1].split("+", 2);
          } else {
            splitTime = splitDateTime[1].split("-", 2);
          }
          date = splitDateTime[0];
          time = splitTime[0];
          let dateTime = `${date} ${time}`;
          //let start: any = moment(dateTime);
          let end: any = moment(dateTime);
          timezone = localStorage.getItem("timezoneName");
          //let end: any = moment(new Date().toLocaleString("en-US", { timeZone: timezone }));
          let start: any = moment(
            new Date().toLocaleString("en-US", { timeZone: timezone })
          );
          hour = start.diff(end, "hours");
          minutes = start.diff(end, "minutes");
          timeDifference = localStorage.getItem("timeDifference");
          timeDifference = timeDifference / 1000;
          timeDifference = parseInt(timeDifference);
          //var timeDiff = start - end;
          var timeDiff = end - start;
          seconds = Math.round(timeDiff);
          {
            timeDifference[0] === "-"
              ? (seconds = seconds - timeDifference)
              : (seconds = seconds + timeDifference);
          }
        }
      }
    }
    setTimeout(() => {
      getLeftTime(startDate);
    }, 1000);
  };

  const renderer = ({
    formatted: { days, hours, minutes, seconds },
    completed,
  }: any) => {
    if (completed) {
      if (
        days === "00" &&
        hours === "00" &&
        minutes === "00" &&
        seconds === "00"
      ) {
        getTimePopup();
        return <span>00:00:00:00</span>;
      }
    } else {
      return (
        <span>
          {days}:{hours}:{minutes}:{seconds}
        </span>
      );
    }
  };

  const getTimePopup = () => {
    if (auctionsState === "Started" && firstTimeExetendPopup === false) {
      setOpenTenderExtended(true);
      setFirstTimeExetendPopup(true);
    }
    setTimeout(() => {
      getAuctionEndTime(props.match.params.auctionId);
    }, 2400);
  };

  //Auction end popup redirection funtion
  const TenderTimeExtended = () => {
    setIsUserClosedExtendedPopup(true);
    setFirstTimeExetendPopup(true);
    getAllUpdatedData();
    getTendorMybidsAucProducts(props.match.params.auctionId, 0, false);
    setOpenTenderExtended(false);
  };

  const setItemsPerPageHandler = (itemsPerPage: number) => {
    setCurrentPage(1);
    jwlItemPerPageRefmybid.current = itemsPerPage;
    setItemsPerPage(itemsPerPage);
  };
  function setCurrentPage(currentPage: number) {
    return currentPage;
  }

  function setItemsPerPage(itemsPerPage: number) {
    return itemPerPage(true, 0, itemsPerPage);
  }
  const itemPerPage = (value: boolean, start: number, itemPerPage: number) => {
    if (value === true) {
      localStorage.setItem("tenderitemsPerPage", JSON.stringify(itemPerPage));
      getUpdatedProducts(value, start, itemPerPage);
    }
  };

  const getUpdatedProducts = (value: any, start: any, endRecords: any) => {
    if (value === true) {
      getProducts(start, endRecords);
    }
  };

  const getProducts = (start: number, end: number) => {
    startCount = start;
    endCount = end;
    localStorage.setItem("currentStart", JSON.stringify(start));
    let Page: any = localStorage.getItem("jwlcurrentPageOfTenderAllProducts");
    PubSub.publish("resetGridBoxIndex", []);
    dispatch(resetTenderGridProductIndexes());
    dispatch(resetTenderjewellerySelectAll());
    onGridSelectionChange(0);
    getBody(props.match.params.auctionId, parseInt(Page), endCount, true);
  };

  const theme = useTheme();
  const notSmallDevices = useMediaQuery(theme.breakpoints.between("md", "xl"));
  let isAuctionPage: any = true;

  const closebidPopup = () => {
    setshowTenderSlider(false);
    setShowBulkBidPopup(false);
  };

  let isCategoryPageType: any = false;

  const handleMyBids = () => {
    //todo
  };

  const TenderauctionEndedModal = () => {
    props.history.push("/auction");
  };

  const addToWatchList = (
    productId: string | number,
    auctionId: string | number
  ) => {
    setOnAction(true);
    setOpenToast(false);
    if (!oAuth()) {
      props.history.push("/");
    } else {
      Auth.postRequest(
        `${productUrl}/${auctionId}/${productId}/watch`,
        "payload",
        (status: any, response: any) => {
          if (response !== undefined) {
            if (status === 200) {
              callApi(payload);
              setIsLoading(false);
              setOnAction(false);
              setShowAlertMessage(`${t("common:preview:addedToWatchMsg")}`);
              setAlertType("success");
              setOpenToast(true);
            } else if (status === 403) {
              setUserBlock(true);
            } else if (status === 404) {
              setIsLoading(false);
              setShowAlertMessage(`${t("common:invalidRequest")}`);
              setOnAction(false);
              setAlertType("error");
              setOpenToast(true);
            } else if (status === 505) {
              setApiTimeout(true);
              setOnAction(false);
            } else {
              setIsLoading(false);
              setShowAlertMessage(response[0].message);
              setOnAction(false);
              setAlertType("error");
              setOpenToast(true);
            }
          } else {
            setIsLoading(false);
            setShowAlertMessage(response);
            setOnAction(false);
            setAlertType("error");
            setOpenToast(true);
          }
        }
      );
    }
  };

  const watchlist = () => {
    localStorage.removeItem("selectedFilterSort");
    PubSub.publish("resetGridBoxIndex", []);
    // props.history.push(
    //   `/watchlist/${props.match.params.auctionId}/${props.match.params.auctionUserId}/${date[0]}/Popcorn`
    // );
    props.history.push("/my-page");
  };

  const filterColorSort = () => {
    //todo
    if (!isColorDataFilter) {
      setmybidProducts(
        mybidProducts.sort((a: any, b: any) =>
          a.sortingColorCode > b.sortingColorCode ? 1 : -1
        )
      );
    } else {
      setmybidProducts(
        mybidProducts.sort((a: any, b: any) =>
          a.sortingColorCode < b.sortingColorCode ? 1 : -1
        )
      );
    }
    setIsColorDataFilter(!isColorDataFilter);
  };

  //grid view sorting
  const filterSort = (sortValue: any, direction: any) => {
    let order = "";
    if (direction === "asc") {
      order = "desc";
    } else {
      order = "asc";
    }
    // calling sorting function and pass sorting
    sortData(sortValue, order);
  };

  const sortData = (values: any, direction: any) => {
    let tempArr: any = [{ property: values, direction: direction }];

    if (direction === "asc") {
      tempArr = [{ property: values, direction: "ASC" }];
    } else {
      tempArr = [{ property: values, direction: "DESC" }];
    }
    console.log(JSON.stringify(tempArr));
    localStorage.setItem("dropDownFilterVal", JSON.stringify(tempArr));
    selectJwlPageUseRef.current = 0;
    localStorage.setItem("currentStart", "0");
    getTendorMybidsAucProducts(props.match.params.auctionId, 0, true);
  };

  const listGridview = () => {
    selectJwlPageUseRef.current = 0;
    localStorage.removeItem("currentStart");
    localStorage.removeItem("annualitemsPerPage");
    setIsLoading(true);
    getTendorMybidsAucProducts(props.match.params.auctionId, 0, true);
    setUiBoxView(true);
    onGridSelectionChange(0);
    PubSub.publish("resetGridBoxIndex", []);
    dispatch(resetTenderJwlIsGridView());
  };

  const Gridview = () => {
    onGridSelectionChange(0);
    PubSub.publish("resetGridBoxIndex", []);
    dispatch(setTenderJwlIsGridView({ gridView: false }));
    setIsLoading(true);
    getBody(props.match.params.auctionId, 0, 100, false);
    setUiBoxView(false);
  };

  useEffect(() => {
    window.addEventListener("scroll", isSticky);
    return () => {
      window.removeEventListener("scroll", isSticky);
    };
  });

  const isSticky = () => {
    const header: any = document.querySelector(".sticky-actionbar");
    const scrollTop = window.scrollY;
  };

  const handleChangeAcco =
    (panel: string) => (event: React.ChangeEvent<{}>, isExpanded: boolean) => {
      setExpanded(isExpanded ? panel : false);
    };
  useEffect(() => {
    let isShowDrawerIcon: any = localStorage.getItem("isShowDrawerIcon");
    isShowDrawerIcon = JSON.parse(isShowDrawerIcon);
    if (isShowDrawerIcon !== null) {
      if (isShowDrawerIcon) {
        const accordionHeader: any = document.querySelector(".AccordionHeader");
        if (accordionHeader !== null) {
          accordionHeader.style.width = isShowDrawerIcon
            ? "calc(100% - 60px)"
            : "calc(100% - 240px)";
        }
      }
    }
  });

  const renderReadOnlyUserToast = async (id: any) => {
    var joinedAuctions: any = localStorage.getItem("joinedAuctions");
    joinedAuctions = JSON.parse(joinedAuctions);
    if (joinedAuctions !== null) {
      joinedAuctions.filter((items: any, index: number) => {
        if (id === items.auctionUserId) {
          isAuctionUserId = true;
        }
      });
    } else {
      if (id === props.match.params.auctionUserId) {
        isAuctionUserId = true;
      } else {
        isAuctionUserId = false;
      }
    }
    await renderPopup();
  };

  const renderPopup = () => {
    if (isReadOnlyUser) {
      setOpenReadOnlyUserToast(true);
    } else if (isAuctionUserId) {
      setOpenReadOnlyUserToast(true);
    } else {
      setOpenReadOnlyUserToast(false);
    }
    setTimeout(() => {
      setOpenReadOnlyUserToast(false);
    }, 3000);
  };

  const colorMybidsFilter = (e: any) => {
    setColorMybidsName(e.target.value);
    const value = e.target.value;
    selectJwlPageUseRef.current = 0;
    localStorage.setItem("currentStart", "0");
    selectJwlPageUseRef.current = 0;
    dispatch(setColorFilter({ color: value }));
  };

  useEffect(() => {
    let totalpay = 0;
    // return filtred array
    let filtredArr =
      colorMybidsName !== "ALL"
        ? mybidProducts?.filter((x: any) => x.colorFilter === colorMybidsName)
        : mybidProducts;
    //calculate total sum of current Bid Price
    filtredArr?.map((x: any) => {
      totalpay = totalpay + x.currentBidPrice;
    });
    bufferTotalPay.current = totalpay;
    setTotalAmount(totalpay);
  }, [colorMybidsName]);

  useEffect(() => {
    let innerwidth: any = window.innerWidth;
    if (innerwidth > 700) {
      if (isGridView) {
        getTendorMybidsAucProducts(props.match.params.auctionId, 0, true);
      } else {
        getBody(props.match.params.auctionId, 0, 100, false);
      }
    } else {
      getTendorMybidsAucProducts(props.match.params.auctionId, 0, true);
    }
  }, [selectedColor]);

  const selectAllInGridView = () => {
    //calling select all function in grid View
    let arr: any = [];
    mybidProducts.map((productVal: any, index: any) => {
      if (arr.length < 10) {
        if (isReadOnlyUser) {
          //
        } else {
          if (
            productVal.sellerAuctionUserId === props.match.params.auctionUserId
          ) {
            //
          } else if (productVal.holdPreviousBidder !== undefined) {
            if (
              props.match.params.auctionUserId === productVal.holdPreviousBidder
            ) {
              //
            } else {
              arr = [...arr, index];
            }
          } else if (productVal.previousBidderId !== undefined) {
            if (
              props.match.params.auctionUserId === productVal.previousBidderId
            ) {
              //
            } else {
              arr = [...arr, index];
            }
          } else if (
            productVal.auctionUserId === props.match.params.auctionUserId
          ) {
            //
          } else {
            if (productVal.auctionUserId === props.match.params.auctionUserId) {
              //
            } else {
              arr = [...arr, index];
            }
          }
        }
      }
    });

    if (isSelected) {
      setIsSelected(false);
      PubSub.publish("resetGridBoxIndex", []);
      arr = [];
      dispatch(resetTenderGridProductIndexes());
      dispatch(resetTenderjewellerySelectAll());
    } else {
      setIsSelected(true);
      dispatch(setTenderGridProductIndexes({ indexes: arr }));
      dispatch(setTenderjewellerySelectAll({ isSelected: true }));
    }
  };

  return (
    <StyledLayoutGrid>
      {isLoading === true ? (
        <div className="loader">
          <LoadingSpinner />
        </div>
      ) : (
        <StyledLayoutGridMain>

          <div style={{ width: "100%", display: "block" }}>
            <StyledHeaderContainer container={true} spacing={0}>
              <StyledCoreDataGridContainer container={true} spacing={0}>
                <StyledActionBarContainer
                  container={true}
                  spacing={0}
                  className="coreActionBarContainer"
                >
                  <StyledContainer>
                    {notSmallDevices ? (
                      <>
                        {isGridView === true ? (
                          <StyledSelectAllButtonHeader
                            onClick={selectAllInGridView}
                          >
                            {t("common:newCommanTrans:selectAll")}
                          </StyledSelectAllButtonHeader>
                        ) : null}
                      </>
                    ) : (
                      <StyledSelectAllButtonHeader
                        onClick={selectAllInGridView}
                      >
                        {t("common:newCommanTrans:selectAll")}
                      </StyledSelectAllButtonHeader>
                    )}
                    <StyledPageSizeSelectorContainer>
                      <select
                        name="sortingControl"
                        onChange={colorMybidsFilter}
                        value={colorMybidsName}
                      >
                        <option value="ALL">----My bids---</option>
                        <option value="ALL">
                          {t("common:colorFilter:all")}
                        </option>
                        <option value="PINK">
                          {t("common:colorFilter:pink")}
                        </option>
                        <option value="ORANGE">
                          {t("common:colorFilter:orange")}
                        </option>
                        <option value="WHITE">
                          {t("common:colorFilter:white")}
                        </option>
                      </select>
                    </StyledPageSizeSelectorContainer>

                    <StyledButtonHeader onClick={watchlist}>
                      {t("common:newCommanTrans:myPage")}
                    </StyledButtonHeader>
                    <StyledButtonHeader onClick={exportExcel}>
                      {t("common:preview:pagination:export")}
                    </StyledButtonHeader>
                  </StyledContainer>
                  <StyledContainer>
                    {showBulkBidButton === true ? (
                      <StyledButtonHeader onClick={bulkBidPopupHandler}>
                        {t("common:preview:tendor:bulkBid")}
                      </StyledButtonHeader>
                    ) : (
                      <></>
                    )}
                  </StyledContainer>
                  {notSmallDevices ? (
                    <>
                      {isGridView === true ? (
                        <ActionTenderPagesize
                          setItemsPerPageHandler={setItemsPerPageHandler}
                          t={t}
                        />
                      ) : null}
                    </>
                  ) : (
                    <ActionTenderPagesize
                      setItemsPerPageHandler={setItemsPerPageHandler}
                      t={t}
                    />
                  )}
                  {notSmallDevices ? (
                    <>
                      {isGridView === true ? (
                        <StyledButtonView onClick={Gridview}>
                          <Styledview src="/images/view/listView.png" />
                        </StyledButtonView>
                      ) : (
                        <StyledButtonView onClick={listGridview}>
                          <Styledview src="/images/view/gridview.jpeg" />
                        </StyledButtonView>
                      )}
                    </>
                  ) : null}
                  <StyledButtonViewFilter onClick={filterColorSort}>
                    <ColorLensIcon />
                  </StyledButtonViewFilter>
                </StyledActionBarContainer>
              </StyledCoreDataGridContainer>
            </StyledHeaderContainer>
          </div>

          <StyledLayoutGrid item={true} xs={12}>
            <div style={{ float: "right", width: "100%", display: "flex" }}>
              {t("common:newCommanTrans:totalAmounts")}:{" "}
              <span style={{ color: "green" }}>{totalAmountLabel}</span>
            </div>

            <div>
              {mybidProducts.length > 0 ? (
                <>
                  {isGridView === false && notSmallDevices && (
                    <MuiThemeProvider theme={getMuiTheme()}>
                      <MUIDataTable
                        title={""}
                        data={mybidProducts}
                        columns={columns}
                        options={options}
                      />
                    </MuiThemeProvider>
                  )}

                  {isGridView === true ? (
                    notSmallDevices && (
                      <>
                        <CoreDataGridOfTenderJwl
                          t={t}
                          data={mybidProducts}
                          totalElements={totalElement}
                          itemPerPage={itemPerPage}
                          value={getUpdatedProducts}
                          noProductFound={handleMyBids}
                          jwlItemPerPageRef={jwlItemPerPageRefmybid.current}
                          selectJwlPageUseRef={selectJwlPageUseRef.current}
                        >
                          {mybidProducts.length > 0 ? (
                            <TenderListOfProductMybids
                              {...props}
                              watchlist={addToWatchList}
                              unWatchlist={removeFromWatchlist}
                              setShowBidPopupBidModal={getBoxIndex}
                              auctionName={props.match.params.auctionName}
                              auctionDate={date[0]}
                              t={t}
                              isAuctionPage={isAuctionPage}
                              isCategoryPageType={isCategoryPageType}
                              boxColor={boxColor}
                              auctionUserId={props.match.params.auctionUserId}
                              sortingValue={filterSort}
                              bulkBidIndexHandler={onGridSelectionChange}
                              myForProductAllProduct={myLatestBidForProduct}
                              renderAutomaticBidPopupInMobile={
                                renderAutomaticBidPopupInMobile
                              }
                              renderReadOnlyUserToast={renderReadOnlyUserToast}
                              rightClickEvent={rightClickEvent}
                            />
                          ) : (
                            <Grid container={true} spacing={0}>
                              <StyledTextWrapper item xs={12}>
                                {t("common:preview:noProductFound")}
                              </StyledTextWrapper>
                            </Grid>
                          )}
                        </CoreDataGridOfTenderJwl>
                      </>
                    )
                  ) : (
                    <></>
                  )}

                  {notSmallDevices || (
                    <>
                      <CoreDataGridOfTenderJwl
                        t={t}
                        data={mybidProducts}
                        totalElements={totalElement}
                        itemPerPage={itemPerPage}
                        value={getUpdatedProducts}
                        noProductFound={handleMyBids}
                        jwlItemPerPageRef={jwlItemPerPageRefmybid.current}
                      >
                        {mybidProducts.length > 0 ? (
                          <TenderListOfProductMybids
                            {...props}
                            watchlist={addToWatchList}
                            unWatchlist={removeFromWatchlist}
                            setShowBidPopupBidModal={getBoxIndex}
                            auctionName={props.match.params.auctionName}
                            auctionDate={date[0]}
                            t={t}
                            isAuctionPage={isAuctionPage}
                            boxColor={boxColor}
                            isCategoryPageType={isCategoryPageType}
                            auctionUserId={props.match.params.auctionUserId}
                            sortingValue={filterSort}
                            bulkBidIndexHandler={onGridSelectionChange}
                            myForProductAllProduct={myLatestBidForProduct}
                            renderAutomaticBidPopupInMobile={
                              renderAutomaticBidPopupInMobile
                            }
                            renderReadOnlyUserToast={renderReadOnlyUserToast}
                            rightClickEvent={rightClickEvent}
                          />
                        ) : (
                          <Grid container={true} spacing={0}>
                            <StyledTextWrapper item xs={12}>
                              {t("common:preview:noProductFound")}
                            </StyledTextWrapper>
                          </Grid>
                        )}
                      </CoreDataGridOfTenderJwl>
                    </>
                  )}

                  {notSmallDevices ? (
                    <>
                      {isGridView === false && (
                        <StyeldShowAllcontainer container={true} spacing={0}>
                          {totalElement > testno ? (
                            <StyledshowAllButton>
                              <StyledButton
                                onClick={() =>
                                  ShowAllProduct(props.match.params.auctionId)
                                }
                              >
                                {t("common:Tender:button:showAll")}
                              </StyledButton>
                            </StyledshowAllButton>
                          ) : (
                            <></>
                          )}
                        </StyeldShowAllcontainer>
                      )}
                    </>
                  ) : null}
                </>
              ) : (
                <Grid container={true} spacing={0}>
                  {notSmallDevices ? (
                    <MuiThemeProvider theme={getMuiTheme()}>
                      <MUIDataTable
                        title={""}
                        data={mybidProducts}
                        columns={columns}
                        options={options}
                      />
                    </MuiThemeProvider>
                  ) : (
                    <StyledTextWrapper item xs={12}>
                      {t("common:preview:noProductFound")}
                    </StyledTextWrapper>
                  )}
                </Grid>
              )}
            </div>
            <Menu
              keepMounted
              open={mouseState.mouseY !== null}
              onClose={handleClose}
              anchorReference="anchorPosition"
              anchorPosition={
                mouseState.mouseY !== null && mouseState.mouseX !== null
                  ? { top: mouseState.mouseY, left: mouseState.mouseX }
                  : undefined
              }
            >
              <MenuItem
                onClick={() =>
                  openDetailsView(
                    props.match.params.auctionId,
                    currentProductId,
                    props.match.params.auctionDate
                  )
                }
              >
                Details
              </MenuItem>
            </Menu>
            {openToast === true && (
              <Alert
                showAlertMessage={showAlertMessage}
                alertType={alertType}
              />
            )}
            {onAction === true && (
              <div className="loading">
                <LoadingSpinner />
              </div>
            )}
            {userBlock === true && (
              <StyledModal open={userBlock}>
                <BlockUserModal t={t} {...props} closeModal={closeModal} />
              </StyledModal>
            )}
            {openEndedModal === true && (
              <StyledModal
                open={openEndedModal}
                onClose={TenderauctionEndedModal}
              >
                <ViewEndedModal
                  t={t}
                  {...props}
                  closeModal={TenderauctionEndedModal}
                />
              </StyledModal>
            )}
            {openTenderExtended === true && (
              <StyledModal
                open={openTenderExtended}
                onClose={TenderTimeExtended}
              >
                <ViewTenderExtendedModal
                  t={t}
                  {...props}
                  closeModal={TenderTimeExtended}
                />
              </StyledModal>
            )}

            {showTenderSlider === true && (
              <StyledModal open={showTenderSlider} onClose={closebidPopup}>
                <JwlTenderSlider
                  t={t}
                  {...props}
                  items={mybidProducts}
                  currentIndex={details}
                  sec={seconds}
                  timeRender={renderer}
                  PopupClose={closebidPopup}
                  handleBtnValue={handleBtnValue}
                  isFirstButtonDisables={isFirstButtonDisable}
                  auctionDate={date[0]}
                  totalElements={totalElement}
                  endCount={endCount}
                  auctionUserId={props.match.params.auctionUserId}
                  length={length}
                  watchedFunction={addToWatchList}
                  unwatched={removeFromWatchlist}
                  boxColor={boxColor}
                />
              </StyledModal>
            )}
            {showBulkBidPopup === true && (
              <StyledModal open={showBulkBidPopup} onClose={closebidPopup}>
                <JwlBulkBidPopup
                  {...props}
                  items={mybidProducts}
                  popupClose={closebidPopup}
                  handleBtnValue={bulkBidHandler}
                  auctionUserId={props.match.params.auctionUserId}
                  length={length}
                  productIndexs={indexsForBulkBidItems}
                  myLatestBidForProducts={myLatestBidForProduct}
                />
              </StyledModal>
            )}
            {openReadOnlyUserToast === true && (
              <AlertReadOnlyUser
                isReadOnlyUser={isReadOnlyUser}
                isSeller={isAuctionUserId}
              />
            )}
          </StyledLayoutGrid>
        </StyledLayoutGridMain>
      )}
    </StyledLayoutGrid>
  );
};

export default TendorJewelleryMyBids;
